<div class="content">
  <h1 mat-dialog-title class="title">
    <mat-icon color="primary" svgIcon="stethoscope"></mat-icon>
    {{ data.title }}
  </h1>
  <p>{{ data.explanation }}</p>
  <div [formGroup]="rosterForm" class="form">
    <mat-form-field class="w-100">
      <mat-label>{{ data.idName }}</mat-label>
      <input matInput type="text" formControlName="patient_id" gcFormField gcFormFieldNoError />
      <mat-error *ngIf="rosterForm.get('patient_id').hasError('required')">* {{ 'this_field_is_required' | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field class="w-100">
      <mat-label>{{ data.rosteredName }}</mat-label>
      <input matInput type="text" formControlName="roster_id" gcFormField gcFormFieldNoError />
      <mat-error *ngIf="rosterForm.get('roster_id').hasError('required')">* {{ 'this_field_is_required' | translate }}</mat-error>
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-flat-button (click)="closeDialog()">{{ 'cancel' | translate }}</button>
    <button mat-raised-button color="primary" (click)="submit()">{{ 'submit' | translate }}</button>
  </div>
</div>
